import React from "react";
import { Card } from "react-bootstrap";

import "./styles.css";

const CardFooter = (props) => {
  return <Card.Footer className="c-footer">{props.children}</Card.Footer>;
};

export default CardFooter;
